<template>
  <div class="myLower">
    <header-box />
    <div class="Subordinate">
      <el-table :data="SubordinateList" height="50vh" stripe style="width: 100%">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column width="180" label="头像">
          <template slot-scope="scope">
            <div>
              <img
                style="width: 100px; border-radius: 5px"
                :src="scope.row.Avatar"
                alt=""
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="NickName" label="用户呢称" width="180">
        </el-table-column>
        <el-table-column prop="Phone" label="手机号码"> </el-table-column>
        <el-table-column label="代理等级">
          <template slot-scope="scope">
            <div v-if="scope.row.Level == 1">一级代理</div>
            <div v-else>二级代理</div>
          </template>
        </el-table-column>
        <el-table-column label="查看下级消费详情">
          <template slot-scope="scope">
            <div @click="ToView(scope.row.Id)">查看</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="下级消费详情"
      center
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div>
        <div class="heade">
          <div>
            <img :src="levelList.Avatar" alt="" />
          </div>
          <div>{{ levelList.NickName }}</div>
          <div style="color: #f00">累计消费￥ {{ levelList.TotalConsume }}</div>
        </div>
        <div class="level">
          <div
            class="list"
            v-for="(item, index) in levelList.OrderDtos"
            :key="index"
          >
            <!-- <div>{{item}}</div> -->
            <div style="margin-bottom:0.3rem;padding-left:0.5rem">下单时间:{{ item.PayTime }}</div>
            <div class="detailsBody">
              <div class="flexBox">
                <div>交货尺寸:</div> <div>{{
                  JSON.parse(item.OrderGoodsDtos[0].OldContent).Det_BoardSiez_H
                }}*{{JSON.parse(item.OrderGoodsDtos[0].OldContent).Det_BoardSize_W}}</div>
              </div>
              <div class="flexBox">
                <div>交货数量:</div>
                <div>{{
                  JSON.parse(item.OrderGoodsDtos[0].OldContent).Det_Num
                }}</div>
              </div>
            </div>
            <div class="flexBox">
                <div>
                    订单总价:{{item.Amount+item.Freight}}
                </div>
                <div>
                    返佣: <span style="color:#f00">￥{{item.CommissionAmount}}</span>
                </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerBox from "../../components/box/headerbox.vue";
import { getUser } from "../../api/http/user";
export default {
  components: {
    headerBox,
  },
  data() {
    return {
      SubordinateList: [], //我的下级
      dialogVisible: false,
      levelList: [], //下级消费详情数组
    };
  },
  created() {
    this.getSubordinateList();
  },
  computed: {},
  methods: {
    ToView(e) {
      this.levelList = "";
      getUser.getSubordinateOrders({ id: e }).then((res) => {
        this.levelList = res.data.data;
        console.log(this.levelList);
        this.dialogVisible = true;
      });
    },
    //   对话框取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //   获取下级用户消费列表
    getSubordinateList() {
      let array=[]
      getUser.getSubordinate().then((res) => {
        if (res.data.code == 200) {
          for(let i=0;i<res.data.data.length;i++){
            if(res.data.data[i].Phone!=''){
              array.push(res.data.data[i])
            }
          }
          this.SubordinateList = array;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flexBox{
    padding: 5px;
    display: flex;
    justify-content: space-between;
}
.detailsBody {
  width: 90%;
  margin: auto;
  background: #ddd;
  border: 1px solid #eee;
  border-radius: 5px;
}
.heade {
  display: flex;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid #999;
  div {
    flex: 1;
    img {
      width: 50px;
      border-radius: 5px;
    }
  }
}
.list {
  margin-top: 0.3rem;
  padding: 5px;
  border: 1px solid #999;
}
.level {
  height: 50vh;

  overflow-y: scroll;
}
.Subordinate {
  width: 90%;
  margin: auto;
  border: 1px solid #999;
  margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/view/my/myLower.vue